/**
 * @module cercaliagl/GeometryType
 */
/**
 * @enum {string}
 */
var GeometryType = {
    /**
     * @api
     */
    POINT: 'Point',
    /**
     * @api
     */
    LINESTRING: 'LineString',
    /**
     * @api
     */
    MULTILINESTRING: 'MultiLineString',
    /**
     * @api
     */
    POLYGON: 'Polygon',
    /**
     * @api
     */
    MULTIPOLYGON: 'MultiPolygon',
};
export default GeometryType;
//# sourceMappingURL=GeometryType.js.map